import { Box, Card, CardActions, CardContent, IconButton, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import OtherHousesIcon from '@mui/icons-material/OtherHouses';

function NotFound() {
  let history = useNavigate();
  const matches = useMediaQuery('(min-width:600px)');
  return (
    <Box className='masthead'>
      <Box sx={{ width: '100%', p: 2, mt: matches ? 20 : 4 }}>
        <Card sx={{ width: matches ? 600 : 360, m: '0 auto', pt: 2, pb: 2 }}>
          <CardContent>
            <Typography sx={{ fontSize: 16, color: 'red' }} color="textSecondary" gutterBottom>
              Oops - we've looked everywhere and could not find this.
            </Typography>
          </CardContent>
          <CardActions>
            <Tooltip title="Go to home" placement="right">
              <IconButton aria-label="add to favorites" onClick={() => history('/')}>
                <OtherHousesIcon />
              </IconButton>
            </Tooltip>
          </CardActions>
        </Card>
      </Box>
    </Box>
  );
}

export default NotFound;